import type { ContractMarisaTakesCare } from '~/domain/MarisaTakesCare/contractMarisaTakesCare';
import type { ContractMarisaTakesCareResponseDTO } from '~/dto/MarisaTakesCare/contractMarisaTakesCare';

export const contractMarisaTakesCareDTOToContractMarisaTakesCare = ({
  resultData: resultDataDto,
  message,
  errors,
  success,
}: ContractMarisaTakesCareResponseDTO): ContractMarisaTakesCare => {
  const resultData = resultDataDto
    ? {
        certificateCode: resultDataDto?.codigoCertificado,
        insuredDocument: resultDataDto?.cpfCnpjSegurado,
      }
    : undefined;

  return {
    resultData,
    message,
    success,
    errors: errors.map((error) => ({
      code: error.errorCode,
      message: error.errorMessage,
    })),
  };
};
